var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTotal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Platform-Admin",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Platform-Admin-/-Question-Bank-New",
    transform: "translate(-120.000000, -178.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stats",
    transform: "translate(96.000000, 152.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(24.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Base",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon/Chart-Column",
    transform: "translate(11.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    x: 0,
    y: 0,
    width: 27,
    height: 27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.53125,4.5 C2.99724026,4.5 3.375,4.85677309 3.375,5.296875 L3.375,20.4375 L26.15625,20.4375 C26.6222403,20.4375 27,20.7942731 27,21.234375 L27,22.828125 C27,23.2682269 26.6222403,23.625 26.15625,23.625 L1.6875,23.625 C0.755519485,23.625 0,22.9114538 0,22.03125 L0,5.296875 C0,4.85677309 0.377759742,4.5 0.84375,4.5 L2.53125,4.5 Z M19.575,9.28125 C19.9125,9.28125 20.25,9.6 20.25,9.91875 L20.25,9.91875 L20.25,16.6125 C20.25,16.93125 19.9125,17.25 19.575,17.25 L19.575,17.25 L17.55,17.25 C17.2125,17.25 16.875,16.93125 16.875,16.6125 L16.875,16.6125 L16.875,9.91875 C16.875,9.6 17.2125,9.28125 17.55,9.28125 L17.55,9.28125 Z M14.5125,6.09375 C14.85,6.09375 15.1875,6.4125 15.1875,6.73125 L15.1875,6.73125 L15.1875,16.6125 C15.1875,16.93125 14.85,17.25 14.5125,17.25 L14.5125,17.25 L12.4875,17.25 C12.15,17.25 11.8125,16.93125 11.8125,16.6125 L11.8125,16.6125 L11.8125,6.73125 C11.8125,6.4125 12.15,6.09375 12.4875,6.09375 L12.4875,6.09375 Z M9.45,12.46875 C9.7875,12.46875 10.125,12.7875 10.125,13.10625 L10.125,13.10625 L10.125,16.6125 C10.125,16.93125 9.7875,17.25 9.45,17.25 L9.45,17.25 L7.425,17.25 C7.0875,17.25 6.75,16.93125 6.75,16.6125 L6.75,16.6125 L6.75,13.10625 C6.75,12.7875 7.0875,12.46875 7.425,12.46875 L7.425,12.46875 Z M24.6375,4.5 C24.975,4.5 25.3125,4.81875 25.3125,5.1375 L25.3125,5.1375 L25.3125,16.6125 C25.3125,16.93125 24.975,17.25 24.6375,17.25 L24.6375,17.25 L22.6125,17.25 C22.275,17.25 21.9375,16.93125 21.9375,16.6125 L21.9375,16.6125 L21.9375,5.1375 C21.9375,4.81875 22.275,4.5 22.6125,4.5 L22.6125,4.5 Z",
    id: "Combined-Shape",
    fill: "#438AE0"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTotal);
export default __webpack_public_path__ + "static/media/icon-total.3750ece3.svg";
export { ForwardRef as ReactComponent };